import React from 'react';
import {LogoSvg} from 'modules/common/components/Svg/LogoSvg';
import {NailBlock} from 'modules/common/components/NailBlock';
import './style.less';
import './consent.less';
import TextInput from 'modules/common/components/TextInput';
import {Button} from 'modules/common/components/Button';
import {AuthApi} from 'modules/api/auth';
import {LabelText} from 'modules/common/components/LabelText';
import {FormattedMessage} from 'react-intl';

class LoginContainer extends React.Component {
    constructor() {
        super();

        this.state = {
            error: null,
            password: '',
        };
    }

    handleChangePassword = (e) => {
        this.setState({
            error: '',
            password: e.currentTarget.value,
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const {password, error} = this.state;

        if (!error) {
            const authApi = new AuthApi();
            const {data, errors} = await authApi.auth({password});
            if (errors) {
                this.setState({
                    error: errors[0].title,
                });
            } else if (data.success) {
                window.location.reload();
            }
        }
    };

    renderError() {
        const {error} = this.state;

        if (!error) {
            return null;
        }

        return <div className="login-container__error">{error}</div>;
    }

    render() {
        const {password, error} = this.state;
        return (
            <div className="login-container">
                <div className="login-container__logo">
                    <LogoSvg width="100%" />
                </div>
                <div className="login-container__status">
                    <LabelText size="big" weight="bold">
                        <FormattedMessage defaultMessage="Hello, please enter your Email" id="GameServer.CSGame.Login/login.enterEmail" />
                    </LabelText>
                </div>
                <div className="login-container__form">
                    <form onSubmit={this.handleSubmit}>
                        <NailBlock className="login-container__nail-block" dark>
                            <LabelText size="big" weight="bold">
                                <FormattedMessage defaultMessage="Password CSGame" id="GameServer.CSGame.Login/login.placeholderPassword">
                                    {(placeholderPassword) => (
                                        <TextInput
                                            className={error ? 'error' : null}
                                            name="login"
                                            onChange={this.handleChangePassword}
                                            placeholder={placeholderPassword}
                                            value={this.state.password}
                                        />
                                    )}
                                </FormattedMessage>
                            </LabelText>
                        </NailBlock>
                        <Button disabled={error || !password.length} type="submit">
                            <FormattedMessage defaultMessage="Log in" id="GameServer.CSGame.Login/anonymousLoginSubmit" />
                        </Button>
                        <div className="login-container__error-wrapper">
                            <LabelText theme="red">{this.renderError()}</LabelText>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export {LoginContainer};
